export default __webpack_public_path__ + "static/media/help-rav-inv-14.04d6a877.png";